module.exports = __webpack_public_path__ + "img/sdg_es_(14).a6bb3627.png";